import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import {
  GlobalStatistics,
  Previous,
  Direct,
  Information,
} from '~/pages/Match/subpages';

export default function SubRouteSwitch() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/global-statistics`} component={GlobalStatistics} />
      <Route path={`${path}/previous`} component={Previous} />
      <Route path={`${path}/direct`} component={Direct} />
      <Route path={`${path}/information`} component={Information} />
    </Switch>
  );
}
